<!--
 * @Author: Wang_jun 1433207604@qq.com
 * @Date: 2022-03-02 15:28:27
 * @LastEditors: Wang_jun 1433207604@qq.com
 * @LastEditTime: 2023-05-22 17:30:24
 * @FilePath: /visaai-platform/src/views/financial/mall/Index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="mall-financial">
    <div class="page-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>{{ $t('common.finance') }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t('financial.breadcrumb.cashAccount') }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="mall-financial__card" v-if="!isRecharge">
      <div class="mall-financial__card-title">
        <span>{{ $t('financial.mall.balanceTitle') }}</span>
        <span>{{ $t('financial.recharge.mallBalanceDesc') }}</span>
      </div>
      <div class="mall-financial__card-amount">
        <div class="mall-financial__card-amount-num">
          <span>{{ balance.mallBalance | filterToYuan }}</span>
          <span>{{ $t('common.yuan') }}</span>
        </div>
        <el-button type="primary" class="page-button_medium" @click="goMallRecharge"
          >{{ $t('financial.payment.rechargeNow') }}</el-button
        >
      </div>
    </div>
    <template v-if="!isRecharge">
      <!-- <page-nav :items="tabItems" v-model="activePageNav"></page-nav> -->
      <!-- <keep-alive> -->
      <component
        :is="currentPage"
        :index="activePageNav"
        :table-height="tableHeight"
      ></component>
      <!-- </keep-alive> -->
    </template>
    <template v-else>
      <div class="page-section">
        <div class="page-section-wallet-amount">
          <div class="page-section-wallet-amount-title">{{ $t('financial.recharge.cashInputTitle') }}</div>
          <div class="page-section-wallet-amount-desc">
            {{ $t('financial.recharge.cashInputDesc') }}
          </div>
          <div class="page-section-wallet-amount-balance">
            <span>{{ $t('financial.mall.balanceTitle') }}</span>
            <span>{{ balance.mallBalance | filterToYuan }} {{ $t('common.yuan') }}</span>
            <el-button class="page-section-wallet-amount-balance-btn" @click="handleBack"
              >{{ $t('financial.payment.back') }}</el-button
            >
          </div>
          <div class="page-section-wallet-amount-input">
            <el-input
              @input="handleInput"
              :placeholder="$t('financial.payment.inputAmount')"
              type="number"
              class="no-number"
              v-model="chooseAmount"
            ></el-input>
            <span>{{ $t('common.yuan') }}</span>
          </div>
          <div class="page-section-wallet-amount-payable">{{ $t('financial.payment.payable') }}</div>
          <div class="page-section-wallet-amount-payableNum">
            {{ chooseAmount ? chooseAmount : "0.00" }} {{ $t('common.yuan') }}
          </div>
        </div>

        <el-card v-if="chooseAmount">
          <div class="page-section-payType" v-loading="payStatus">
            <div class="page-section-payType-title">{{ $t('financial.payment.payMethod') }}</div>
            <div class="page-section-payType-box">
              <div class="page-section-payType-box-scan">
                <div class="page-section-payType-box-scan-header">{{ $t('financial.payment.scanPay') }}</div>
                <img
                  class="page-section-payType-box-scan-url"
                  :src="payScanData.codeImgUrl"
                  alt=""
                />
                <p>{{ $t('financial.payment.scanHint') }}</p>
                <img
                  src="https://bn-visas.oss-cn-hangzhou.aliyuncs.com/onlineImg/img_pay_ali%402x.png"
                  alt=""
                  class="page-section-payType-box-scan-alipay"
                />
                <img
                  src="https://bn-visas.oss-cn-hangzhou.aliyuncs.com/onlineImg/img_pay_we%402x.png"
                  alt=""
                  class="page-section-payType-box-scan-wechat"
                />
              </div>
              <div class="page-section-payType-box-bank">
                <div class="page-section-payType-box-bank-header">{{ $t('financial.payment.bankTransfer') }}</div>
                <img
                  src="https://bn-visas.oss-cn-hangzhou.aliyuncs.com/onlineImg/ic_bank%402x.png"
                  alt=""
                />
                <p>{{ $t('financial.payment.accountNo') }}</p>
                <p>571911902610901</p>
                <p>{{ $t('financial.payment.accountName') }}</p>
                <p>{{ $t('financial.payment.bankAccountName') }}</p>
                <p>{{ $t('financial.payment.bankName') }}</p>
                <p>{{ $t('financial.payment.bankBranch') }}</p>
              </div>
            </div>
          </div>
        </el-card>
      </div>
      <el-dialog :visible.sync="payDialogSync" class="payDialogSync" width="400px">
        <div class="payDialogSync-content">
          <i class="el-icon-success payDialogSync-i"></i>
          <span class="payDialogSync-text">{{ $t('financial.payment.rechargeSuccess') }}</span>
        </div>
        <div slot="footer" class="payDialogSync-footer">
          <el-button type="primary" @click="handleRefresh">{{ $t('financial.payment.continueRecharge') }}</el-button>
          <el-button type="primary" @click="handleRecode">{{ $t('financial.payment.viewRecords') }}</el-button>
        </div>
      </el-dialog>
    </template>
  </div>
</template>

<script>
import { getFinancialTabs } from '@/data/financialTabs'
import { mapGetters } from "vuex";
import MallRecharge from "./Recharge";
import MallExpenditure from "./Expenditure";
import _ from "lodash";
import * as toolApi from "@/apis/tool";
export default {
  name: "mallFinancial",
  data() {
    return {
      isRecharge: false,
      tableHeight: 0,
      activePageNav: "recharge",

      pollingPayStatus: false,
      payStatus: false,
      payDialogSync: false,
      payScanData: {},
      chooseAmount: "",
    };
  },

  mounted() {
    this.tableHeight = window.innerHeight - 317;
  },
  computed: {
    ...mapGetters(["balance"]),
    tabItems() {
      return getFinancialTabs(this.$t.bind(this))
    },
    currentPage() {
      let page = null;
      switch (this.activePageNav) {
        case "recharge":
          page = MallRecharge;
          break;
        case "expenditure":
          page = MallExpenditure;
          break;
      }
      return page;
    },
  },
  methods: {
    handleRefresh() {
      // this.$router.go(0);
      this.chooseAmount = "";
      this.payDialogSync = false;
    },
    handleRecode() {
      this.isRecharge = false;
    },
    handleBack() {
      this.isRecharge = false;
    },
    pollPayStatus() {
      this.pollingPayStatus = setInterval(async () => {
        let status = await this.getPayStatus();
        console.log(status, "status");
        if (status) {
          //最大轮询30次，及90秒后，关闭轮询
          clearInterval(this.pollingPayStatus);
        }
      }, 2000);
      this.$once("hook:beforeDestroy", () => {
        clearInterval(this.pollingPayStatus);
      });
    },
    async getPayStatus() {
      try {
        const result = await toolApi.getPayStatus({
          outTradeNo: this.payScanData.outTradeNo,
        });
        if (result) {
          if (result.payStatus === "TRADE_SUCCESS") {
            this.payDialogSync = true;
            return true;
          } else {
            return false;
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    async getPayScan() {
      this.payStatus = true;
      const result = await toolApi.getZmpayV2({
        payFromEnum: "MALL_WALLET",
        totalAmount: this.chooseAmount * 100,
        returnUrl: "https://b.visaai.com/pay-transfer.html",
      });
      if (result) {
        this.payStatus = false;
        this.payScanData = result;
        clearInterval(this.pollingPayStatus);
        this.pollPayStatus();
      } else {
        this.payStatus = false;
      }
    },
    goMallRecharge() {
      this.isRecharge = true;
    },
    handleInput: _.debounce(function () {
      this.$forceUpdate();
      if (this.chooseAmount < 0) {
        this.chooseAmount = "";
      } else {
        this.getPayScan();
      }
    }, 1000),
  },
};
</script>

<style lang="scss">
.mall-financial {
  .no-number::-webkit-outer-spin-button,
  .no-number::-webkit-inner-spin-button {
    margin: 0;
    -webkit-appearance: none !important;
  }

  .no-number input[type="number"]::-webkit-outer-spin-button,
  .no-number input[type="number"]::-webkit-inner-spin-button {
    margin: 0;
    -webkit-appearance: none !important;
  }
  &__card {
    background-color: #ffffff;
    border: 1px solid #dcdfe6;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.04);
    padding: 16px 60px;
    margin-bottom: 20px;
    &-title {
      margin-bottom: 20px;
      span:nth-child(1) {
        color: rgba(0, 0, 0, 0.65);
        margin-right: 10px;
      }
      span:nth-child(2) {
        color: rgba(0, 0, 0, 0.45);
      }
    }
    &-amount {
      display: flex;
      &-num {
        span:nth-child(1) {
          font-size: 28px;
          font-weight: 500;
          margin-right: 5px;
        }
        span:nth-child(2) {
          font-display: 12px;
        }
        margin-right: 50px;
      }
    }
  }
  .page-section {
    &-wallet {
      &-amount {
        padding: 24px;
        position: relative;

        &-title {
          font-size: 16px;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.87);
        }

        &-desc {
          font-size: 13px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.38);
          margin: 8px 0 24px;
        }
        &-balance {
          position: absolute;
          right: 24px;
          top: 24px;
          display: flex;
          align-items: center;

          span:nth-child(1) {
            font-size: 14px;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.6);
            margin-right: 8px;
          }

          span:nth-child(2) {
            font-size: 20px;
            font-weight: 500;
            color: #ff6f00;
          }
          &-btn {
            margin-left: 10px;
            span:nth-child(1) {
              margin-right: 0;
            }
          }
        }

        &-input {
          width: 664px;
          position: relative;

          input {
            height: 64px;
            font-size: 24px;
            font-weight: 500;
            color: rgba(0, 0, 0, 0.87);
          }

          span:nth-child(2) {
            position: absolute;
            right: 14px;
            top: 14px;
            font-size: 24px;
            font-weight: 500;
            color: rgba(0, 0, 0, 0.38);
          }
        }

        &-payable {
          font-size: 16px;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.87);
          margin: 24px 0 16px;
        }

        &-payableNum {
          height: 56px;
          border-radius: 4px;
          background: rgba(255, 167, 38, 0.12);
          line-height: 56px;
          text-indent: 16px;
          color: #ff6f00;
          font-weight: 500;
          font-size: 24px;
        }
      }
    }
    &-payType {
      width: 664px;

      &-title {
        font-size: 16px;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.87);
      }

      &-box {
        display: flex;

        &-scan {
          position: relative;
          margin-right: 8px;

          &:after {
            content: "";
            position: absolute;
            right: -8px;
            top: 0;
            width: 1px;
            height: 330px;
            background: rgba(0, 0, 0, 0.08);
          }

          width: 320px;

          &-header {
            height: 48px;
            background: #eef9ff;
            border-radius: 4px;
            line-height: 48px;
            text-indent: 24px;
            font-size: 16px;
            font-weight: 500;
            color: #0094e8;
            margin: 16px 0;
          }

          &-url {
            width: 160px;
            height: 160px;
            margin-left: 24px;
          }

          p {
            margin-left: 24px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.6);
          }

          &-alipay {
            width: 40px;
            height: 40px;
            margin-left: 24px;
          }

          &-wechat {
            width: 40px;
            height: 40px;
            margin-left: 17px;
          }
        }

        &-bank {
          margin-left: 8px;
          width: 328px;

          img {
            width: 56px;
            height: 56px;
            margin-left: 24px;
          }

          &-header {
            height: 48px;
            background: #eef9ff;
            border-radius: 4px;
            line-height: 48px;
            text-indent: 24px;
            font-size: 16px;
            font-weight: 500;
            color: #0094e8;
            margin: 16px 0;
          }

          p:nth-child(3) {
            font-size: 12px;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.38);
            margin: 16px 0 4px 24px !important;
          }

          p:nth-child(4) {
            font-size: 16px;
            font-weight: 500;
            color: rgba(0, 0, 0, 0.87);
            margin: 0 0 8px 24px !important;
          }

          p:nth-child(5) {
            font-size: 12px;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.38);
            margin: 0 0 4px 24px !important;
          }

          p:nth-child(6) {
            font-size: 14px;
            font-weight: 500;
            color: rgba(0, 0, 0, 0.87);
            margin: 0 0 4px 24px !important;
          }

          p:nth-child(7) {
            font-size: 12px;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.38);
            margin: 0 0 4px 24px !important;
          }

          p:nth-child(8) {
            font-size: 14px;
            font-weight: 500;
            color: rgba(0, 0, 0, 0.87);
            margin: 0 0 4px 24px !important;
          }
        }
      }
    }
    .payDialogSync {
      &-i {
        color: #00bf94;
        font-size: 50px;
        margin-right: 15px;
      }

      &-content {
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: 500;
        margin: 20px 0;
      }

      .payDialogSync-text {
        font-size: 20px;
      }

      &-footer {
        display: flex;
        justify-content: center;
      }
    }
  }
}
</style>
